export default {
    // 本地环境
    // apiUrl:'http://127.0.0.7:9501/Api/',
    // uploadUrl:'http://127.0.0.7:9501/Api/Upload/upload',
    // assetsUrl:'http://127.0.0.7:9501',
    // 开发环境
    // baseUrl:'http://api.dev-clb.org.cn',
    // apiUrl:'http://api.dev-clb.org.cn/Api/',
    // uploadUrl:'http://api.dev-clb.org.cn/Api/Upload/upload',
    // assetsUrl:'http://api.dev-clb.org.cn/static',
   
    // 正式环境
    baseUrl:'http://api.clb.org.cn',
    apiUrl:'http://api.clb.org.cn/Api/',
    uploadUrl:'http://api.clb.org.cn/Api/Upload/upload',
    assetsUrl:'http://api.clb.org.cn/static',

    secret:'zhaobiaowang!@#',
    WX_CONFIG:{
        appId: 'wxaba3b39896537f78',
        serviceAppId:'wx3c492ac64b672617'
    },
}
